import type { User } from '../types';
import { MixpanelAnalytics } from './analytics';

export function syncAnalyticsUserIdentity(user: Pick<User, 'id' | 'email' | 'name' | 'userType'>): void {
  MixpanelAnalytics.identify({
    user_id: user.id,
    email: user.email,
    name: user.name,
    user_type: user.userType,
  });
}

export function clearAnalyticsUserIdentity(): void {
  MixpanelAnalytics.reset();
}
